import { render, staticRenderFns } from "./PieChartPlaceholder.vue?vue&type=template&id=afb08a70&scoped=true&"
import script from "./PieChartPlaceholder.vue?vue&type=script&lang=js&"
export * from "./PieChartPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb08a70",
  null
  
)

export default component.exports